// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"0":"b44877b55416de71","81":"c279ed219469be86","83":"d56a72caa09199fb","235":"e879ab168cdd36ef","403":"20088bbcdc0df92c","464":"da88eefa2194ebf0"}[chunkId] + ".js";
};